export default __webpack_public_path__ + "static/media/package-info.a41f0853.png";